.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.range-products-tab {
  position: relative;
}

@media screen and (max-width: 979px) {
  .range-products-tab {
    display: block;
    padding-bottom: 24px;
  }
}

@media screen and (min-width: 980px) {
  .range-products-tab {
    display: flex;
    flex-direction: column;
    overflow: visible;
    padding-bottom: 48px;
  }
}

.range-products-tab__nodes-wrapper {
  padding-top: 32px;
}

.range-products-tab__container {
  display: flex;
  flex-direction: column;
}

.range-products-tab__main-block-container {
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 980px) {
  .range-products-tab__main-block-container {
    flex-direction: row;
  }
}

@media screen and (max-width: 979px) {
  .range-products-tab__products-count {
    color: #626469;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 12px;
  }
}

@media screen and (min-width: 980px) {
  .range-products-tab__products-count {
    display: none;
  }
}

.range-products-tab__products {
  padding-top: 24px;
  position: relative;
}

@media screen and (min-width: 980px) {
  .range-products-tab__products {
    padding-top: 36px;
  }
}

.range-products-tab__products--desktop {
  display: none;
}

@media screen and (min-width: 980px) {
  .range-products-tab__products--desktop {
    display: initial;
    overflow: visible;
  }
}

@media screen and (min-width: 980px) {
  .range-products-tab__products-list {
    display: block;
  }

  :host(:not([dir="rtl"])) .range-products-tab__products-list {
    margin-left: 20px;
  }

  :host([dir="rtl"]) .range-products-tab__products-list {
    margin-right: 20px;
  }
}

.range-products-tab__overlay {
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fafafa;
  opacity: 0.4;
}

.range-products-tab__overlay:not(.range-products-tab__overlay--visible) {
  display: none;
}

@media screen and (max-width: 979px) {
  .range-products-tab__overlay {
    position: fixed;
  }
}

@media screen and (min-width: 980px) {
  .range-products-tab__overlay {
    position: absolute;
  }
}

.range-products-tab__desktop-pagination {
  width: 100%;
  text-align: center;
  margin-top: 36px;
}

@media screen and (max-width: 979px) {
  .range-products-tab__desktop-pagination {
    display: none;
  }
}

.range-products-tab__load-prev-btn {
  margin-bottom: 20px;
}

.range-products-tab__load-more-btn {
  margin-top: 20px;
}

@media screen and (min-width: 980px) {
  .range-products-tab__load-prev-btn,
.range-products-tab__load-more-btn {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .range-products-tab__rich-text {
    margin-left: 20px;
  }

  :host([dir="rtl"]) .range-products-tab__rich-text {
    margin-right: 20px;
  }
}

@media screen and (min-width: 980px) {
  .range-products-tab__filters {
    padding-top: 36px;
    max-width: 280px;
  }
}